import React, { FC } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

interface InfoModalProps {
  title: string;
  description: string;
  open: boolean;
  handleClose: () => void;
}

export const InfoModal: FC<InfoModalProps> = (props: InfoModalProps) => {
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="info-dialog-title"
      aria-describedby="info-dialog-description"
    >
      <DialogTitle id="info-dialog-title">{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="info-dialog-description">{props.description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} variant={"contained"} color="primary" autoFocus disableElevation>
          CHIUDI
        </Button>
      </DialogActions>
    </Dialog>
  );
};
